module.exports = __webpack_public_path__ + "2e7b0286.svg";